import { Stack, Box } from '@chakra-ui/react'
import { SectionTitle } from '@!/Store/Common/components'
import { ScrollableContent } from '@!/Store/Home/components'
import { Title } from './Title'

/* 横スクロール型のタイトルリスト */
export const ScrollableTitles = ({ titles, tabName, sectionTitle, url }) => {
  return (
    <Stack spacing={0} mx={4}>
      <SectionTitle title={sectionTitle} url={url} tabName={tabName} />
      <ScrollableContent>
        <Stack direction="row" spacing={0}>
          {titles.map((title) => (
            <Box key={`${sectionTitle}-${title.title_id}`} mr={3}>
              <Title
                titleId={title.title_id}
                titleName={title.title_name}
                imageUrl={title.image_url}
                sectionTitle={tabName ? `${tabName}_${sectionTitle}` : undefined}
              />
            </Box>
          ))}
        </Stack>
      </ScrollableContent>
    </Stack>
  )
}
